import { createClassName } from 'utils/createClassName';

import './sidebarModalStyles.scss';

export const createSidebarModalWindowClassName = createClassName(
  'sidebarModalWindow'
);
export const createSidebarModalSectionClassName = createClassName(
  'sidebarModalSection'
);

export const createSidebarModalBlockClassName = createClassName(
  'sidebarModalBlock'
);

export const createSidebarModalSplitClassName = createClassName(
  'sidebarModalSplit'
);
